import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './ResourceViewerModal.scss';
import { trackEvent } from '../../lib/analytics';

interface ResourceViewerModalProps {
  url: string;
  title: string;
  buttonClassName?: string;
  buttonStyle?: React.CSSProperties;
  children: React.ReactNode;
}

const ResourceViewerModal: React.FC<ResourceViewerModalProps> = ({
  url,
  title,
  buttonClassName,
  buttonStyle,
  children,
}) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
    try {
      trackEvent('resource_modal_open', { title, url });
    } catch {}
  };
  const handleClose = () => setShow(false);

  // Basic URL validation and allowlist
  let safeUrl: string | null = null;
  try {
    const parsed = new URL(url, window.location.origin);
    const allowedProtocols = new Set(['https:', 'http:', 'data:', 'blob:']);
    if (allowedProtocols.has(parsed.protocol)) {
      // Prefer same-origin; allow others only for https/data/blob
      safeUrl = parsed.toString();
    }
  } catch {
    safeUrl = null;
  }
  const isPdf = !!safeUrl && safeUrl.toLowerCase().endsWith('.pdf');

  return (
    <>
  <button type="button" onClick={handleShow} className={buttonClassName} style={buttonStyle}>
        {children}
      </button>

      <Modal show={show} onHide={handleClose} size="xl" centered className="resource-modal">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="resource-modal-body">
          {!safeUrl ? (
            <p className="text-danger">Invalid or unsupported resource URL.</p>
          ) : isPdf ? (
            <div className="pdf-container">
              <iframe
                src={safeUrl}
                title={title}
                width="100%"
                height="100%"
                sandbox="allow-same-origin"
                referrerPolicy="no-referrer"
                loading="lazy"
              />
              <p className="mt-2">
                If the PDF does not display, you can{' '}
                <a href={safeUrl} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">
                  open it in a new tab
                </a>
                .
              </p>
            </div>
          ) : (
            <img
              src={safeUrl}
              alt={title}
              className="object-fit-contain border rounded w-100"
              referrerPolicy="no-referrer"
              loading="lazy"
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ResourceViewerModal;
